import { createUseStyles } from "react-jss";
export const ControllerStyle = createUseStyles((theme: any) => ({
container : {
    "& p":{
        marginTop:"5px"
    }
}  

}));
